module.exports = __webpack_public_path__ + "media/icons/linkedin@2x-4f4692c3.png";